import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'

export function convert(data) {
    return request({
        url: "/app/vip/convert/convert",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}


// WEBPACK FOOTER //
// ./src/api/vip.js